(ns minorodata.analytics.api
  (:require
   ["date-fns" :refer [formatISO]]
   [mold-http.core :refer [reg-event-http]]))


(defn sources-request [{:keys [db]} _]
  (let [timeframe (get-in db [:analytics :timeframe])]
    {:http-xhrio
     {:id     :analytics-sources
      :url    "/api/analytics/sources"
      :params {:from (some-> (:from timeframe) formatISO)
               :to  (some-> (:to timeframe) formatISO)}}}))

(defn sources-callback [{:keys [db]} [error resp]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to load analytics sources data"]}
    {:db (update-in db [:analytics :summary] merge resp)}))

(reg-event-http
 :analytics.api/fetch-sources
 sources-request
 sources-callback)


(defn extracts-request [{:keys [db]} _]
  (let [timeframe (get-in db [:analytics :timeframe])]
    {:http-xhrio
     {:id     :analytics-extracts
      :url    "/api/analytics/extracts"
      :params {:from (some-> (:from timeframe) formatISO)
               :to  (some-> (:to timeframe) formatISO)}}}))

(defn extracts-callback [{:keys [db]} [error resp]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to load analytics extracts data"]}
    {:db (update-in db [:analytics :summary] merge resp)}))

(reg-event-http
 :analytics.api/fetch-extracts
 extracts-request
 extracts-callback)


(defn transforms-request [{:keys [db]} _]
  (let [timeframe (get-in db [:analytics :timeframe])]
    {:http-xhrio
     {:id     :analytics-transforms
      :url    "/api/analytics/transforms"
      :params {:from (some-> (:from timeframe) formatISO)
               :to  (some-> (:to timeframe) formatISO)}}}))

(defn transforms-callback [{:keys [db]} [error resp]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to load analytics transforms data"]}
    {:db (update-in db [:analytics :summary] merge resp)}))

(reg-event-http
 :analytics.api/fetch-transforms
 transforms-request
 transforms-callback)


(defn activity-request [{:keys [db]} _]
  (let [timeframe (get-in db [:analytics :timeframe])]
    {:http-xhrio
     {:id     :analytics-activity
      :url    "/api/analytics/activity"
      :params {:from (some-> (:from timeframe) formatISO)
               :to  (some-> (:to timeframe) formatISO)}}}))

(defn activity-callback [{:keys [db]} [error resp]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to load analytics activity data"]}
    {:db (update-in db [:analytics :summary] merge resp)}))

(reg-event-http
 :analytics.api/fetch-activity
 activity-request
 activity-callback)
